import React from "react"
import PropTypes from "prop-types"
import DocumentsSlide from "../DocumentsSlide/DocumentsSlide"
import Carousel from "../Carousel"
import Brochure from "../Brochure"

export default function NewsTabBrochure(props) {
  const { files, title = "Información:" } = props

  const renderCarrousel = () => {
    if (files && files.length <= 4) {
      return <div>{renderSlidesDocs()}</div>
    }
    return (
      <Carousel
        arrowRight={<i className="fas fa-arrow-right"></i>}
        arrowLeft={<i className="fas fa-arrow-left"></i>}
        className="Topicality-carousel"
        useArrows
      >
        {renderSlidesDocs()}
      </Carousel>
    )
  }

  const renderSlidesDocs = () => {
    if (files && files.length <= 4) {
      return files.map((file, i) => {
        return (
          <div key={i}>
            <Brochure text={file.title} link={file.file} blank />
          </div>
        )
      })
    }
    return (
      files &&
      [1, 2, 3, 4, 5].map((item, index) => {
        return (
          <DocumentsSlide slides={files?.slice(index * 6, (index + 1) * 6)} />
        )
      })
    )
  }

  return (
    <div className="NewsTab-borderTop">
      <span className="NewsTab-title" style={{ marginTop: 10 }}>
        {title}
      </span>
      {renderCarrousel()}
    </div>
  )
}

NewsTabBrochure.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, file: PropTypes.string }),
  ),
  title: PropTypes.string,
}
